class CollectionFilters {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.loadFiltersFromUrl();
  }

  bindEvents() {
    document.addEventListener('change', (e) => {
      if (e.target.matches('.filter-option input[type="checkbox"]')) {
        this.applyFilters();
      }
    });
  }

  loadFiltersFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const filters = urlParams.get('filter.v.m.product_type');
    
    if (filters) {
      const filterArray = filters.split('|');
      filterArray.forEach(filter => {
        const checkbox = document.getElementById(filter);
        if (checkbox) checkbox.checked = true;
      });
    }
  }

  applyFilters() {
    const selectedFilters = [];
    const checkboxes = document.querySelectorAll('.filter-option input[type="checkbox"]:checked');
    
    checkboxes.forEach(checkbox => {
      selectedFilters.push(checkbox.value);
    });

    this.updateUrl(selectedFilters);
  }

  updateUrl(filters) {
    const url = new URL(window.location);
    
    if (filters.length > 0) {
      url.searchParams.set('filter.v.m.product_type', filters.join('|'));
    } else {
      url.searchParams.delete('filter.v.m.product_type');
    }

    window.location.href = url.toString();
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CollectionFilters();
});